module.exports = __webpack_public_path__ + "c167f22d163850449b92ce053d1787ae.svg";